"use strict";

module.exports = function (column, e) {
  //console.log('dragstart->'+column)
  this.opts.ColumnDragging = column;
};


// WEBPACK FOOTER //
// ./src/components/vuetable-2-kernel/compiled/methods/dragstart-column.js